'use strict';

const _=require('pulsar-utils/dist-es6/_');let

FdcConfig=class FdcConfig{
constructor($stateProvider,$urlRouterProvider,$locationProvider,$httpProvider,$mdInkRippleProvider,$logProvider,$compileProvider){
$mdInkRippleProvider.disableInkRipple();

let _goToDefaultFeature;
$urlRouterProvider.otherwise(function($injector){
const $state=$injector.get('$state');
const fatigueMeterTypeContentProviderService=$injector.get('fatigueMeterTypeContentProviderService');

if(_goToDefaultFeature){
_goToDefaultFeature();
return;
}

fatigueMeterTypeContentProviderService.setupDefaultFeatureForUser(defaultFeature=>{
_goToDefaultFeature=_.debounce(()=>$state.go(defaultFeature));
_goToDefaultFeature();
});

$state.go(fatigueMeterTypeContentProviderService.defaultFeature);






});

$locationProvider.html5Mode({
enabled:!1,
requireBase:!1});


$httpProvider.useApplyAsync(!0);

$stateProvider.
state('fdc',{
abstract:!0,
views:{
header:{
templateUrl:'/templates/layout/header'},

alerts:{
templateUrl:'/templates/layout/alerts'},

tooltips:{
templateUrl:'/templates/layout/tooltips'}}}).



state('fdc.features',{
abstract:!0});


if("production"==='production'){

$logProvider.debugEnabled(!1);
$compileProvider.debugInfoEnabled(!1);








}

FastClick.attach(document.body);
}};


module.exports=FdcConfig;

let _initialized=!1;
module.exports.runFunction=$rootScope=>{
if(_initialized)
return;

_initialized=!0;
if("production"==='development'){
$rootScope.$on('$stateChangeError',(event,toState,toParams,fromState,fromParams,error)=>{
console.error('Got $stateChangeError:');
console.error(error);
});
}
};
module.exports.runFunction.$inject=['$rootScope'];
//# sourceMappingURL=fdcConfig.js.map
